import {
  Fieldset as HeadlessUIFieldset,
  FieldsetProps as HeadlessUIFieldsetProps,
  Legend,
} from '@headlessui/react';

export type FieldsetProps = {
  legend: React.ReactNode;
  description?: React.ReactNode;
} & Omit<HeadlessUIFieldsetProps, 'className'>;

/**
 * <Fieldset />
 *
 * To style the children of the fieldset using container queries, add the
 * `@container/fieldset` class to elements passed as children.
 */
export const Fieldset = ({
  legend,
  description,
  children,
  ...rest
}: FieldsetProps) => {
  return (
    <HeadlessUIFieldset {...rest} className="text-zinc-800 @container/fieldset">
      {(bag) => {
        return (
          <>
            <Legend as="legend" className="flex flex-col gap-y-2">
              <div>{legend}</div>

              {description && (
                <div className="text-sm text-gray-600">{description}</div>
              )}
            </Legend>

            <div className="mt-4">
              {typeof children === 'function' ? children(bag) : children}
            </div>
          </>
        );
      }}
    </HeadlessUIFieldset>
  );
};
